// utils/validations/validateIndividualExcel.js
export const validateIndividualExcel = (data) => {
  const errors = [];

  if (!data || data.length === 0) {
    errors.push("Uploaded Excel file is empty.");
    return errors;
  }

  // --- Helpers ---
  const getValue = (row, keyPart) => {
    const key = Object.keys(row).find((k) =>
      k.toLowerCase().includes(keyPart.toLowerCase())
    );
    return row[key];
  };

  const clean = (val) => String(val || "").trim();

  // Excel date number → dd-mm-yyyy
  const formatExcelDate = (value) => {
    if (!value) return "";
    if (typeof value === "number") {
      const date = new Date((value - 25569) * 86400 * 1000);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    }
    if (value instanceof Date) {
      const day = String(value.getDate()).padStart(2, "0");
      const month = String(value.getMonth() + 1).padStart(2, "0");
      const year = value.getFullYear();
      return `${day}-${month}-${year}`;
    }
    return clean(value);
  };

  // --- Regex patterns ---
  const nameRegex = /^[A-Za-z\s]+$/; // letters only
  const emailRegex =
    /^(?!.*\.\.)(?!.*@@)([a-zA-Z0-9._%+-]+)@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
  const pincodeRegex = /^\d{6}$/;
  const mobileRegex = /^\d{10}$/;
  const dateRegex = /^\d{2}-\d{2}-\d{4}$/;
  const textNoEmojiRegex = /^[\w\s.,;:/#'"\-@!$%^&*()_+=?]*$/u;

  const allowedTypes = ["residential centre", "coe"];
  const allowedGenders = ["M", "F"];

  data.forEach((row, index) => {
    const rowNum = index + 1;

    // --- Extract & Clean ---
    const firstName = clean(getValue(row, "first name"));
    const middleName = clean(getValue(row, "middle name"));
    const lastName = clean(getValue(row, "last name"));
    const fatherName = clean(getValue(row, "father name"));
    const motherName = clean(getValue(row, "mother name"));
    const dob = formatExcelDate(getValue(row, "date of birth"));
    const gender = clean(getValue(row, "gender")).toUpperCase();
    const mobile = clean(getValue(row, "mobile"));
    const email = clean(getValue(row, "email"));
    const address = clean(getValue(row, "address"));
    const landmark = clean(getValue(row, "landmark"));
    const pincode = clean(getValue(row, "pincode"));
    const Sport = clean(getValue(row, "Sport"));
    const kitsize = clean(getValue(row, "kitsize"));
    const SelectShoeSize = clean(getValue(row, "Date of Joining in the Training centre"));
    const joiningDate = formatExcelDate(getValue(row, "date of joining"));

    const centreName = clean(getValue(row, "Name of Centre (Athletes Centre Details)"));
    const district = clean(getValue(row, "district"));

    // --- VALIDATIONS ---

    // NAME FIELDS
    if (!firstName) errors.push(`Row ${rowNum}: First Name is required.`);
    else if (!nameRegex.test(firstName))
      errors.push(`Row ${rowNum}: First Name must contain only letters (no numbers or symbols).`);

    if (middleName && !nameRegex.test(middleName))
      errors.push(`Row ${rowNum}: Middle Name must contain only letters (no numbers or symbols).`);

    if (lastName && !nameRegex.test(lastName))
      errors.push(`Row ${rowNum}: Last Name must contain only letters (no numbers or symbols).`);



    if (fatherName && !nameRegex.test(fatherName))
      errors.push(`Row ${rowNum}: Father Name must contain only letters (no numbers or symbols).`);


    if (motherName && !nameRegex.test(motherName))
  errors.push(`Row ${rowNum}: Mother Name must contain only letters (no numbers or symbols).`);


    // DATE OF BIRTH
    if (!dob) errors.push(`Row ${rowNum}: Date of Birth is required.`);
    else if (!dateRegex.test(dob))
      errors.push(`Row ${rowNum}: Date of Birth must be in dd-mm-yyyy format.`);

    // GENDER
    if (!gender) errors.push(`Row ${rowNum}: Gender is required.`);
    else if (!allowedGenders.includes(gender))
      errors.push(`Row ${rowNum}: Gender must be either 'M' or 'F'.`);

    // MOBILE (optional)
    if (mobile && !mobileRegex.test(mobile))
      errors.push(`Row ${rowNum}: Mobile number must be a valid 10-digit number.`);

    // EMAIL
    if (!email) errors.push(`Row ${rowNum}: Email is required.`);
    else if (!emailRegex.test(email))
      errors.push(`Row ${rowNum}: Invalid email format.`);

    // ADDRESS
    if (!address) errors.push(`Row ${rowNum}: Address is required.`);
    else if (!textNoEmojiRegex.test(address))
      errors.push(`Row ${rowNum}: Address contains invalid characters or emojis.`);

    // LANDMARK
   if (landmark && !textNoEmojiRegex.test(landmark))
  errors.push(`Row ${rowNum}: Landmark contains invalid characters or emojis.`);

    // PINCODE
    if (!pincode) errors.push(`Row ${rowNum}: Pincode is required.`);
    else if (!pincodeRegex.test(pincode))
      errors.push(`Row ${rowNum}: Pincode must be a 6-digit number.`);
    if (!Sport)
      errors.push(`Row ${rowNum}: Sport  must be selected from dropdown.`);
    // KIT SIZE (dropdown)
    if (!kitsize)
      errors.push(`Row ${rowNum}: Kit size must be selected from dropdown.`);

    // DATE OF JOINING
    if (!joiningDate)
      errors.push(`Row ${rowNum}: Date of Joining in the Training centre is required.`);
    else if (!dateRegex.test(joiningDate))
      errors.push(`Row ${rowNum}: Date of Joining must be in dd-mm-yyyy format.`);

    // TYPE (dropdown)
    if (!SelectShoeSize) {
      errors.push(`Row ${rowNum}: ShoeSize must be selected.`);
    }

    // CENTRE NAME (dropdown)
    if (!centreName)
      errors.push(`Row ${rowNum}: Name of Centre must be selected.`);

    // DISTRICT (dropdown)
    if (!district)
      errors.push(`Row ${rowNum}: District must be selected.`);
  });

  return errors;
};



